import { breakpoints } from "../../../../../utilities/sal-breakpoint/sal-breakpoint";
import * as Hammer from "hammerjs";
import { animation, availableAnimations } from "../../../../../global/global-animation";

let options = {
    galleryClass: 'gallery',
    galleryWrapper: 'gallery-wrapper',
    galleryImageWrapper: 'ce-gallery__lightbox',
    galleryImageClass: 'gallery__image',
    galleryImageActive: 'js-gallery-active-image',
    galleryAnimationDuration: '250ms',
    galleryTouchThreshold: 80,
    breakpointCondition: () => {
        return window.innerWidth >= breakpoints.lg;
    },
};

const eventHandler = {
    nextImage: e => {
        const nextButton = e.target;
        const galleryContainer = nextButton.closest(`.js-gallery-controls`).previousElementSibling;
        let activeImage = galleryContainer.querySelector(`.${options.galleryImageActive}`);

        if (activeImage.nextElementSibling) {
            const galleryWrapperReference = galleryContainer.querySelector(`.${options.galleryImageWrapper}`);
            const distance = Math.abs(activeImage.getBoundingClientRect().left - (activeImage.nextElementSibling.getBoundingClientRect().left - activeImage.scrollWidth));

            galleryWrapperReference.style.cssText = `left: ${parseInt(galleryWrapperReference.style.left) - (activeImage.scrollWidth + distance)}px`;
            activeImage.nextElementSibling.classList.add(options.galleryImageActive);
            activeImage.classList.remove(options.galleryImageActive);
            activeImage = activeImage.nextElementSibling;

            if (!activeImage.nextElementSibling) {
                e.target.classList.add('inactive');
            } else if (nextButton.parentNode.querySelector('.js-gallery-prev').classList.contains('inactive')) {
                e.target.parentNode.querySelector('.js-gallery-prev').classList.remove('inactive');
            }
        }
    },
    prevImage: e => {
        const prevButton = e.target;
        const galleryContainer = prevButton.closest(`.js-gallery-controls`).previousElementSibling;
        let activeImage = galleryContainer.querySelector(`.${options.galleryImageActive}`);

        if (activeImage.previousElementSibling) {
            const galleryWrapperReference = galleryContainer.querySelector(`.${options.galleryImageWrapper}`);
            const distance = Math.abs(activeImage.getBoundingClientRect().left - (activeImage.previousElementSibling.getBoundingClientRect().left + activeImage.previousElementSibling.getBoundingClientRect().width));

            galleryWrapperReference.style.cssText = `left: ${parseInt(galleryWrapperReference.style.left) + (activeImage.previousElementSibling.scrollWidth + distance)}px`;
            activeImage.previousElementSibling.classList.add(options.galleryImageActive);
            activeImage.classList.remove(options.galleryImageActive);
            activeImage = activeImage.previousElementSibling;
            if (!activeImage.previousElementSibling) {
                e.target.classList.add('inactive');
            } else if (e.target.parentNode.querySelector('.js-gallery-next').classList.contains('inactive')) {
                e.target.parentNode.querySelector('.js-gallery-next').classList.remove('inactive');
            }
        }
    },
    panDetected: e => {
        if (!options.breakpointCondition()) {
            if (e.isFinal) {
                if (e.additionalEvent === 'panleft') {
                    const triggeredGallery = e.target.closest(`.${options.galleryImageWrapper}`);
                    const activeImage = triggeredGallery.querySelector(`.${options.galleryImageActive}`);
                    const nextImage = activeImage.nextElementSibling ? activeImage.nextElementSibling : null;

                    if (nextImage) {
                        animation.addAnimation(activeImage, availableAnimations.slides.slideOutLeft, options.galleryAnimationDuration, [
                            {
                                eventType: 'animationend',
                                eventCallback: (e) => {
                                    e.target.classList.remove(options.galleryImageActive);

                                    nextImage.classList.add(options.galleryImageActive);
                                    animation.addAnimation(nextImage, availableAnimations.slides.slideInRight, options.galleryAnimationDuration, [
                                        {
                                            eventType: 'animationend',
                                            eventCallback: e => {
                                                const wrapper = e.target.closest(`.${options.galleryWrapper}`);
                                                const activeIndicator = wrapper.querySelector('.indicator--active');
                                                activeIndicator.classList.remove('indicator--active');
                                                activeIndicator.nextElementSibling.classList.add('indicator--active');
                                            }
                                        }
                                    ]);
                                }
                            }
                        ]);
                    }
                }
                if (e.additionalEvent === 'panright') {
                    const triggeredGallery = e.target.closest(`.${options.galleryImageWrapper}`);
                    const activeImage = triggeredGallery.querySelector(`.${options.galleryImageActive}`);
                    const prevImage = activeImage.previousElementSibling ? activeImage.previousElementSibling : null;

                    if (prevImage) {
                        animation.addAnimation(activeImage, availableAnimations.slides.slideOutRight, options.galleryAnimationDuration, [
                            {
                                eventType: 'animationend',
                                eventCallback: (e) => {
                                    e.target.classList.remove(options.galleryImageActive);

                                    prevImage.classList.add(options.galleryImageActive);
                                    animation.addAnimation(prevImage, availableAnimations.slides.slideInLeft, options.galleryAnimationDuration, [
                                        {
                                            eventType: 'animationend',
                                            eventCallback: e => {
                                                const wrapper = e.target.closest(`.${options.galleryWrapper}`);
                                                const activeIndicator = wrapper.querySelector('.indicator--active');
                                                activeIndicator.classList.remove('indicator--active');
                                                activeIndicator.previousElementSibling.classList.add('indicator--active');
                                            }
                                        }
                                    ]);
                                }
                            }
                        ]);
                    }
                }
            }
        }
    }
};

const actions = {
    positionGalleryImages: (gallery, reference) => {
        const offset = reference.getBoundingClientRect().left;
        gallery.style.cssText = `left: ${offset}px`;
    },
    addButtons: (insertAfter) => {
        const buttonWrapper = document.createElement('div');
        buttonWrapper.classList.add('js-gallery-controls');
        const nextBtn = document.createElement('button');
        nextBtn.classList.add('js-gallery-next');
        const prevBtn = document.createElement('button');
        prevBtn.classList.add('js-gallery-prev');

        const activeImages = document.querySelectorAll(`.${insertAfter} .${options.galleryImageActive}`);

        activeImages.forEach(activeImage => {
            if (!activeImage.nextElementSibling) {
                nextBtn.classList.add('inactive');
            }

            if (!activeImage.previousElementSibling) {
                prevBtn.classList.add('inactive');
            }

        });

        buttonWrapper.appendChild(prevBtn);
        buttonWrapper.appendChild(nextBtn);

        const references = document.querySelectorAll(`.${insertAfter}`);
        references.forEach(reference => {
            const closestContainer = reference.closest(`.edge-container`, `.container`);
            closestContainer.parentNode.insertBefore(buttonWrapper.cloneNode(true), closestContainer.nextSibling);
            closestContainer.nextElementSibling.querySelector('.js-gallery-next').addEventListener('click', eventHandler.nextImage);
            closestContainer.nextElementSibling.querySelector('.js-gallery-prev').addEventListener('click', eventHandler.prevImage);
        })
    },
    removeButtons: () => {
        const nextButtons = document.querySelectorAll(`.js-gallery-next`);
        const prevButtons = document.querySelectorAll(`.js-gallery-prev`);

        nextButtons.forEach(btn => {
            btn.parentNode.removeChild(btn);
        });

        prevButtons.forEach(btn => {
            btn.parentNode.removeChild(btn);
        });
    },
    createIndicator: (numberOfIndicators) => {
        let i = 0;
        let indicatorWrapper = document.createElement('div');
        indicatorWrapper.classList.add('gallery__indicator');
        let indicator = document.createElement('span');
        indicator.classList.add('indicator');

        while (i < numberOfIndicators) {
            indicatorWrapper.appendChild(indicator.cloneNode(true));
            i++;
        }

        indicatorWrapper.firstChild.classList.add('indicator--active');

        return indicatorWrapper;
    }
};

const gallery = {
    init: (overwriteOptions) => {
        Object.assign(options, overwriteOptions);

        const galleryInstances = document.querySelectorAll(`.${options.galleryClass}`);
        galleryInstances.forEach(gallery => {
            const reference = gallery.previousElementSibling.querySelector('header');
            const galleryImages = gallery.querySelector(`.${options.galleryImageWrapper}`);

            if (options.breakpointCondition()) {
                actions.positionGalleryImages(galleryImages, reference);
            }

            gallery.querySelector(`.${options.galleryImageClass}`).classList.add(options.galleryImageActive);

            let hammerInstances = [];
            if (!options.breakpointCondition()) {
                const touchArea = galleryImages;
                const numberIndicators = touchArea.childNodes.length;

                if (touchArea.nextSibling) {
                    touchArea.parentNode.insertBefore(actions.createIndicator(numberIndicators), touchArea.nextSibling);
                } else {
                    touchArea.parentNode.append(actions.createIndicator(numberIndicators));
                }

                const hammerInstance = new Hammer(touchArea);
                hammerInstance.get('pan').set({direction: Hammer.DIRECTION_HORIZONTAL, threshold: options.galleryTouchThreshold});
                hammerInstance.on('pan', eventHandler.panDetected);
                hammerInstances.push(hammerInstance);
            }
        });

        window.addEventListener('resize', () => {
            galleryInstances.forEach(gallery => {
                const reference = gallery.previousElementSibling.querySelector('header');
                const galleryImages = gallery.querySelector(`.${options.galleryImageWrapper}`);
                if (options.breakpointCondition()) {
                    actions.positionGalleryImages(galleryImages, reference);
                }
            });

            if (document.querySelector('.js-gallery-next') === null && options.breakpointCondition()) {
                actions.addButtons(options.galleryWrapper);
            }

            if (document.querySelector('.js-gallery-next') !== null && !options.breakpointCondition()) {
                actions.removeButtons(options.galleryWrapper);
            }
        });

        if (options.breakpointCondition()) {
            actions.addButtons(options.galleryWrapper);
        }
    }
};

export {gallery}
